// Section for import npm components -----------------------------------------------------------------------------------
import React, { useContext } from 'react';

// MUI components
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';

// Section for import custom components --------------------------------------------------------------------------------
import { useMeta } from '@providers/MansionNavigation/MetaProvider';
import { useSelectedLines } from '@providers/MansionNavigation/SelectedLinesProvider';
import { AppConfigContext } from '@providers/AppConfigProvider';

import filterEntries from '@components/MansionNavigation/Utils/Filters';
import generateSortQuery from '@components/MansionNavigation/Utils/Sort';

// Section for type definition -----------------------------------------------------------------------------------------
const multiLinesUrlPrefix: string = '/karte/';

export default function LinesSearch(props: any) {
  const { selectedPrefecture } = props;
  const { isMobile } = useContext(AppConfigContext);
  const { meta } = useMeta();
  const selectedLines = useSelectedLines();

  const switchButtonStyle: string = selectedLines.length === 0 ? 'hidden' : 'block';
  const buttonStylePC: string = `relative group p-0 shadow-none ${switchButtonStyle}`;
  const buttonStyleSp: string = `relative group p-0 shadow-none w-full max-md:mt-8 ${switchButtonStyle}`;

  const filterQuery = filterEntries(meta.filters, ['line_id'])
    ? `&${filterEntries(meta.filters, ['line_id'])}${generateSortQuery(meta.sort, '&')}`
    : `${generateSortQuery(meta.sort, '&')}`;

  const onSubmit = () => {
    // バリデーションチェックOK！なときに行う処理を追加
    window.location.href = `${
      multiLinesUrlPrefix + selectedPrefecture.pref_code_name
    }/stations/?line_id=${selectedLines.join(',')}${filterQuery}`;
  };

  // Section for render component --------------------------------------------------------------------------------------
  return (
    // Section for render Mobile mode ----------------------------------------------------------------------------------
    <Box className="flex justify-center md:bottom-5 bottom-0 sticky md:mt-10 max-md:mx-0 max-md:px-5">
      <FormControl className="max-md:w-full">
        <Box className="w-full text-center max-md:py-5">
          <Button
            color="primary"
            variant="contained"
            size="large"
            onClick={onSubmit}
            className={`${isMobile ? buttonStyleSp : buttonStylePC}`}
          >
            <Box className="rf-btn-lg-spMax">マンションを探す</Box>
            <ArrowForwardRoundedIcon className="hidden group-hover:block w-5 max-md:block absolute right-4 -translate-y-2/4 top-2/4 text-[#191919]" />
          </Button>
        </Box>
      </FormControl>
    </Box>
  );
}
